import React from 'react'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'

export default class StepPersonalDetails extends React.Component {
  render() {
    return (
      <>
        <p className={styles.question}>Please provide your contact details.</p>
        <div className={styles.formText}>
          <label htmlFor="email">Email</label>
          <input
            type="text"
            className={styles.formTextInput}
            id="email"
            name="email"
            value={this.props.email}
            onChange={this.props.handleChange}
          />
        </div>
        <div className={styles.formText}>
          <label htmlFor="fullName">Full Name</label>
          <input
            type="text"
            className={styles.formTextInput}
            id="fullName"
            name="fullName"
            value={this.props.fullName}
            onChange={this.props.handleChange}
          />
        </div>
        <div className={styles.formText}>
          <label htmlFor="telephone">Telephone</label>
          <input
            type="number"
            className={styles.formTextInput}
            id="telephone"
            name="telephone"
            value={this.props.telephone}
            onChange={this.props.handleChange}
          />
        </div>
        <div className={styles.formCheck}>
          <input
            type="checkbox"
            checked={this.props.acceptTerms}
            className={styles.formCheckInput}
            id="acceptTerms"
            name="acceptTerms"
            value={this.props.acceptTerms}
            onChange={this.props.handleAcceptTerms}
          />
          <label htmlFor="acceptTerms">
            I accept the <a href={'/terms/'} target="_blank" rel="noreferrer" className={styles.termsLink}>T&Cs</a>
          </label>
        </div>
        <p className={styles.acceptTermsInfo}>Your privacy is important to us. We only use this information to provide you with accurate quotes.</p>
        <p className={styles.errorMessage}>{this.props.errorMessage}</p>
      </>
    )
  }
}

StepPersonalDetails.propTypes = {
  email: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  telephone: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  acceptTerms: PropTypes.bool.isRequired,
  handleAcceptTerms: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
}